// extracted by mini-css-extract-plugin
export default {"Badges":"styles_Badges__MCwBv","HeaderButtonWrapper":"styles_HeaderButtonWrapper__dt-v0","Icon":"styles_Icon__zIKCE","Button":"styles_Button__V1map"};